@import (reference) '../../../../../constants/spacing.module.less';

.carrier-logo {
  height: 20px;
  width: 20px;
}

.request-number {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;
}
